import React from "react"
import { Rate as RateVant } from "react-vant"
import { RateProps as RateVantProps } from "react-vant/es/rate"
import { cls } from "reactutils"

export type RateProps = RateVantProps & {
  className?: string
  showScore?: boolean
  scoreGutter?: number
  scoreSize?: number
  text?: number | string
  showText?: boolean
  textGutter?: number
  textSize?: number
}

export default function Rate({
  className,
  value,
  readonly = true,
  allowHalf = true,
  size = 12,

  showScore = true,
  scoreGutter = 5,
  scoreSize = 12,

  showText = false,
  text = "",
  textGutter = 30,
  textSize = 15,

  color = "#FA5401",
  voidColor = "#D8D8D8",
  isPercent = false,
  ...others
}: RateProps) {
  return (
    <div className={cls("rate-container", className)}>
      <RateVant
        value={isPercent ? value / 20 : +value}
        readonly={readonly}
        allowHalf={allowHalf}
        size={size}
        color={color}
        voidIcon="star"
        voidColor={voidColor}
        {...others}
      />
      {showScore && <span className="score">{value}</span>}
      {showText && <span className="text">{text}</span>}
      <style jsx>{`
        .rate-container {
          display: flex;
          align-items: center;
        }
        .score {
          margin-left: ${scoreGutter}px;
          line-height: ${scoreSize}px;
          font-size: ${scoreSize}px;
          font-weight: bold;
          color: ${color};
        }
        .text {
          margin-left: ${textGutter}px;
          font-size: ${textSize}px;
          color: ${color};
        }
      `}</style>
    </div>
  )
}
